package com.tovtalk.ui.screen.splash

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.tovtalk.ui.components.TovTalkNoConnectionState
import com.tovtalk.ui.theme.TovTalkTheme

/**
 * Shown only when the app has no network on launch.
 * User can tap Retry to return to Splash and try loading again.
 */
@Composable
fun OfflineLaunchScreen(
    onRetry: () -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(TovTalkTheme.colors.backgroundPrimary)
    ) {
        TovTalkNoConnectionState(
            onRetry = onRetry,
            modifier = Modifier
                .fillMaxSize()
                .padding(TovTalkTheme.spacing.xl)
        )
    }
}
